import commissionListComponent from "@/components/commission/CommissionListComponent.vue";
import Error from "@/views/error/error.vue";
import { isConsultantOrHolding } from "@/js/http/auth";
export default {
  name: "adminCommissionsList",
  props: ["loggedUserData"],
  data: function data() {
    return {
      role: process.env.VUE_APP_ROLES_MANAGE_COMMISSION_CONSULTANT
    };
  },
  methods: {
    isConsultantOrHolding: isConsultantOrHolding
  },
  components: {
    commissionListComponent: commissionListComponent,
    Error: Error
  }
};